<div class="header">
  <ng-container *ngIf="!searchOpened">
    <div class="title bold">{{ 'classrooms.invite.title' | translate }}</div>
    <app-icon class="icon" icon="search" [width]="18" [height]="18"
              data-test="open-search"
              (click)="openSearch()"></app-icon>
  </ng-container>

  <ng-container *ngIf="searchOpened">
    <div class="search-field">
      <app-search-input [formControl]="searchControl"></app-search-input>
    </div>
    <app-icon class="icon" icon="close" [width]="18" [height]="18" (click)="closeSearch()"></app-icon>
  </ng-container>
</div>
